module.exports = __webpack_public_path__ + "img/wocozon-app.441a1ccf.png";